import { useContext } from "react";
import { StoriesContext } from "../../context/stories";

export default () => useContext(StoriesContext);
